export default __webpack_public_path__ + "static/media/pin-selected-new-theme.15228be8.svg";